export default "__VITE_ASSET__BrKhbN3N__"